module.exports = __webpack_public_path__ + "static/media/figure15.0fbab4bf.png";